import { MOBILE_HEADER_HEIGHT } from 'omakase/Header/headerCssDefs';
import { Theme, css } from '@emotion/react';
import { Typography } from 'omakase';
import React from 'react';

interface AccountPageMobileHeadingProps {
  /**
   * Use this to apply additional styles, probably via a css= definition.
   * Note that the component itself provides its own styles, if you specify something
   * in conflict with the builtin defs, the builtin defs will win.
   */
  className?: string;
}

const AccountPageMobileHeading: React.FunctionComponent<AccountPageMobileHeadingProps> = ({
  children,
  className,
}) => (
  <Typography
    className={className}
    css={({ breakpoints, colors, spacing, zIndex }: Theme) => css`
      background-color: ${colors.bgDefault};
      padding-top: 1em;
      padding-bottom: 1em;
      margin-bottom: ${spacing(0.25)}px;
      position: sticky;
      top: ${MOBILE_HEADER_HEIGHT}px;
      z-index: ${zIndex.bump};

      ${breakpoints.up('sm')} {
        display: none;
      }
    `}
    variant="heading02"
    color="fgDefault"
    component="h1"
  >
    {children}
  </Typography>
);

export default AccountPageMobileHeading;
